import classNames from "classnames/bind";
import styles from "../../CaseChatCard.module.scss";
const cx = classNames.bind(styles);
function CaseChatCard({ avatarUrl,
                          lastMessage,
                          senderName,
                          status,
                          supportCaseId,
                          caseTitle,
                          active,
                          onClick,
                          unreadCount
}) {
    const statusMap = {
        active: { label: "active", className: "badge bg-success" },
        awaiting: { label: "awaiting your reply", className: "badge bg-warning" },
    };
    const badge = statusMap[status] || statusMap.awaiting;

    return (
        <div onClick={onClick} className= {cx(`${active ? "case-card-active" : ""}`, "border-bottom border-translucent py-3 position-relative px-3 cursor-pointer")}>
            <div className="d-flex align-items-center justify-content-between position-relative">
                <div className="d-flex w-100">
                    <div className="me-3 status-online avatar avatar-m flex-shrink-0 position-relative">
                        <img alt="avatar" className="rounded-circle" src={avatarUrl} />
                        {unreadCount > 0 && (
                            <span
                                className={cx("unread-badge-anim", "position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger")}
                            >
                              {unreadCount}
                            </span>
                        )}
                    </div>
                    <div className="flex-grow-1 w-100">
                        <div className="d-flex justify-content-between align-items-center">
                            <h4 className="fs-9 mb-0 text-body-emphasis">{senderName}</h4>
                            <span className={badge.className}>{badge.label}</span>
                        </div>
                        <div className="d-flex justify-content-between my-2">
                          <span className={cx("text-ellipsis", "case-title", "me-1 fs-9")}>
                            {caseTitle}
                          </span>
                            <span className="me-1 fw-semibold fs-10">{supportCaseId}</span>
                        </div>
                        <p className={cx("text-ellipsis",
                                    "last-message",
                                    unreadCount > 0 ? "unread" : "",
                                    unreadCount > 0 ? "fw-bold text-primary" : "text-body-secondary",
                                    "fs-9 mb-0"
                        )}>
                            {lastMessage}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CaseChatCard;